import React, { FC, useLayoutEffect } from 'react';
import { useSelector } from 'react-redux';
import { useHistory, useLocation } from 'react-router-dom';
// types
import { stateType } from '../../types/types';
// routing
import routes from '../../config/routes';
import { withAuth } from '../../hocs/withAuth';
import PageTransition from '../atoms/pageTransition';
import { applyExamShellBackground, isExamStageRoute } from '../../tools';

interface DoctorLayoutProps {
  component: React.FunctionComponent<any>;
  path: string | Array<string>;
  exact: boolean;
  location?: { state: { roomId: string } };
  isIntegration: boolean;
}

const DoctorLayout: FC<DoctorLayoutProps> = ({ component: Component, ...args }: DoctorLayoutProps) => {
  const history = useHistory();
  const pathname = useLocation().pathname;

  // App shell is the exam stage gray on every doctor route.
  useLayoutEffect(() => {
    applyExamShellBackground(isExamStageRoute(pathname) ? 'stage' : 'admin');
  }, [pathname]);

  // store
  const userType = useSelector((state: stateType) => state.user.user.userType);

  // make these method more dynamic by accessing routes with [] for more userTypes
  const otherUserRedirect = () => {
    setTimeout(() => {
      history.push(userType === 'patient' ? routes.patient.safeRoute : routes.patientRemote.safeRoute);
    }, 0);
  };

  const integrationRedirect = () => {
    setTimeout(() => {
      history.push('/connect');
    }, 0);
  };

  if (userType !== 'doctor') {
    return <>{otherUserRedirect()}</>;
  } else if (args.isIntegration && args.path === '/doctor_home') {
    return <>{integrationRedirect()}</>;
  }
  return (
    <PageTransition>
      <Component {...args} />
    </PageTransition>
  );
};

export default withAuth(DoctorLayout);
